<template>
  <div class="dashboard-container">
    <!-- 头部导航栏 -->
    <a-layout-header style="background: url('/assets/dpwDashboard/Dashboard_Banner_Bg2.png'); background-position: left 20px center; padding: 0; display: flex; justify-content: space-between; align-items: center; color: white;height: 90px">
      <div style="display: flex; align-items: center; margin-left: 20px;">
        <img src="/assets/dpwDashboard/dp_world_logo_white.png"  style="margin-right: 10px; width: 172px;height: 42px" />
      </div>
      <div style="display: flex; align-items: center; margin-right: 20px;">
        <div class="outline-rounded-box" style="font-size: 14px"  @click="previous">
          <img src="/assets/dpwDashboard/dashboard_previous_icon.png" style="width: 15px;height: 15px" />
          {{ $t("login.previous") }}
        </div>
        <img src="/assets/dpwDashboard/Dashboard_ecwms_logo_white.png"  style="margin-right: 10px;" />
        <span style="font-size: 24px">{{ $t("login.dashboardPortal") }}</span>
        <div class="outline-rounded-box" style="font-size: 16px"  @click="logout">{{ $t("login.signOut") }}
          <img src="/assets/dpwDashboard/dashboard_signout_icon.png"  style="width: 15px;height: 15px" />
        </div>

      </div>
    </a-layout-header>

    <!-- 主内容区 -->
    <a-layout-content style="padding: 20px; background: #fff; height: calc(100vh - 90px); overflow-y: auto;">
      <a-row :gutter="[20, 20]" style="height: 100%;">

        <iframe title="DP Storage Utilization-HKG"
                style="border: none;clip-path: inset(0 0 37px 0);"
                height="100%"
                width="100%"
                :src="getSrcUrl()"
                frameborder="0"
                allowFullScreen="true"
        />



      </a-row>
    </a-layout-content>
  </div>
</template>

<script>
    import ajax from "@/api/ajax";
    import api from "@/api/url";
    import sessionManager from "@/utils/session-manager";

    export default {
        name: 'Dashboard',
        data() {
          return {
            dashboardCards: [],
            urlData:'',
          }
        },
        mounted() {
            this.adjustImageSize();  // 在组件挂载后调用调整图片的函数
            window.addEventListener("resize", this.adjustImageSize);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.adjustImageSize);  // 清理事件监听
        },
        created() {
          this.urlData = this.$route.query.url;
          this.init()
        },
        methods: {
            getSrcUrl() {
              return this.urlData;
            },

            adjustImageSize() {
                const image = document.getElementById("responsiveImage");
                if (!image) return;  // 防止 null 错误

                if (window.innerWidth <= 768) {
                    // 在手机端，图片高度和宽度都占满屏幕
                    image.style.width = "100vw";
                    image.style.height = "100vh";
                    image.style.objectFit = "cover";
                } else {
                    // 在桌面端，保持原有的比例
                    image.style.width = "auto";
                    image.style.height = "100%";
                    image.style.objectFit = "contain";
                }
            },
            clearBtn() {
                this.$router.push({
                    path: "/moose/customerInfo",
                });
            },

            queryBtn() {
                this.$router.push({
                    path: "/moose/washing",
                });
            },
          init() {

          },


          languageSelectChange(language) {
              let returnLanguage = '';

              if(language == 'zh') {
                returnLanguage = '简体中文 / S. Chinese';
              } else if (language == 'zh_tw') {
                returnLanguage = '繁體中文 / T. Chinese';
              } else if (language == 'kor') {
                returnLanguage = '한국어 / Korean';
              } else if (language == 'jp') {
                returnLanguage = '日本語 / Japanese';
              } else {
                returnLanguage = 'English';
              }

              return returnLanguage;
          },
          logout() {
            ajax.get(api.USERLOGOUTLOGINACCOUNT).then(res=>{
              sessionManager.clearUserData();
              this.$router.push({path: "/dashboard/login"})
              this.leftMenuActive = '0'
            })
          },
          previous() {
            this.$router.push({
              path: "/dashboard/home"
            });
          },


        }
    };
</script>

<style scoped>
.outline-rounded-box {
  border: 1px solid #fff;
  border-radius: 12px;
  margin: 20px;
  height: 40px;
  line-height: 40px;
  width: 120px;
  text-align: center;
}
.dashboard-container {
  min-height: 100vh;
}

.dashboard-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dashboard-card .ant-card-head-title {
  font-size: 16px;
  font-weight: bold;
}

.dashboard-card p {
  margin: 12px 0;
  font-size: 14px;
  color: #555;
}

.dashboard-card .ant-btn {
  margin-top: 10px;
}

    .custom-button:hover  span {
        color: #56b8e1 !important; /* 悬停时子元素字体颜色 */
    }

    .container {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .image {
        max-height: 100%;
        width: auto;
        object-fit: contain;
    }
</style>
